import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  ngOnInit()
  {
   this.changeColor('grey'); 
  }
  changeColor(color:string){
    document.documentElement.style.setProperty('--dynamic-color', color);
   
   }
}
